webpackJsonp([247658369337294],{

/***/ "./node_modules/create-react-class/factory.js":
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__("./node_modules/object-assign/index.js");
	
	var emptyObject = __webpack_require__("./node_modules/fbjs/lib/emptyObject.js");
	var _invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ "./node_modules/create-react-class/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	var factory = __webpack_require__("./node_modules/create-react-class/factory.js");
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ "./node_modules/react-timeout/src/reactTimeout.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var createReactClass = __webpack_require__("./node_modules/create-react-class/index.js")
	var objectAssign = __webpack_require__("./node_modules/object-assign/index.js")
	
	var createReactTimeout = function (React) {
	  var GLOBAL = typeof window === 'undefined' ? global : window
	
	  var setter = function (_setter, _clearer, array) {
	    return function (callback, delta) {
	      var id = _setter(function () {
	        _clearer.call(this, id)
	        callback.apply(this, arguments)
	      }.bind(this), delta)
	
	      if (!this[array]) {
	        this[array] = [id]
	      } else {
	        this[array].push(id)
	      }
	      return id
	    }
	  }
	
	  var clearer = function (_clearer, array) {
	    return function (id) {
	      if (this[array]) {
	        var index = this[array].indexOf(id)
	        if (index !== -1) {
	          this[array].splice(index, 1)
	        }
	      }
	      _clearer(id)
	    }
	  }
	
	  var _timeouts = '_ReactTimeout_timeouts'
	  var _clearTimeout = clearer(GLOBAL.clearTimeout, _timeouts)
	  var _setTimeout = setter(GLOBAL.setTimeout, _clearTimeout, _timeouts)
	
	  var _intervals = '_ReactTimeout_intervals'
	  var _clearInterval = clearer(GLOBAL.clearInterval, _intervals)
	  var _setInterval = setter(GLOBAL.setInterval, function () {}, _intervals)
	
	  var _immediates = '_ReactTimeout_immediates'
	  var _clearImmediate = clearer(GLOBAL.clearImmediate, _immediates)
	  var _setImmediate = setter(GLOBAL.setImmediate, _clearImmediate, _immediates)
	
	  var _rafs = '_ReactTimeout_rafs'
	  var _cancelAnimationFrame = clearer(GLOBAL.cancelAnimationFrame, _rafs)
	  var _requestAnimationFrame = setter(GLOBAL.requestAnimationFrame, _cancelAnimationFrame, _rafs)
	
	  var cloneArray = function (a) {
	    return (!a || typeof a.slice !== 'function') ? [] : a.slice(0)
	  }
	
	  var ReactTimeout = function (SourceComponent) {
	    return createReactClass({
	      displayName: 'ReactTimeout',
	
	      setTimeout: _setTimeout,
	      clearTimeout: _clearTimeout,
	
	      setInterval: _setInterval,
	      clearInterval: _clearInterval,
	
	      setImmediate: _setImmediate,
	      clearImmediate: _clearImmediate,
	
	      requestAnimationFrame: _requestAnimationFrame,
	      cancelAnimationFrame: _cancelAnimationFrame,
	
	      componentWillUnmount: function () {
	        cloneArray(this[_timeouts]).forEach(this.clearTimeout)
	        cloneArray(this[_intervals]).forEach(this.clearInterval)
	        cloneArray(this[_immediates]).forEach(this.clearImmediate)
	        cloneArray(this[_rafs]).forEach(this.cancelAnimationFrame)
	      },
	
	      render: function () {
	        return React.createElement(
	          SourceComponent,
	          objectAssign(
	            {},
	            this.props,
	            {
	              setTimeout: this.setTimeout,
	              clearTimeout: this.clearTimeout,
	
	              setInterval: this.setInterval,
	              clearInterval: this.clearInterval,
	
	              setImmediate: this.setImmediate,
	              clearImmediate: this.clearImmediate,
	
	              requestAnimationFrame: this.requestAnimationFrame,
	              cancelAnimationFrame: this.cancelAnimationFrame
	            }))
	      }
	    })
	  }
	
	  return ReactTimeout
	}
	
	module.exports = createReactTimeout
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ "./node_modules/react-timeout/src/web.js":
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js")
	var createReactTimeout = __webpack_require__("./node_modules/react-timeout/src/reactTimeout.js")
	
	module.exports = createReactTimeout(React)


/***/ }),

/***/ "./src/components/Couple.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  padding: 4rem 2rem;\n  align-content: stretch;\n  ", ";\n"], ["\n  display: flex;\n  padding: 4rem 2rem;\n  align-content: stretch;\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    padding: 1rem 0;\n    padding-top: 500px;\n  "], ["\n    padding: 1rem 0;\n    padding-top: 500px;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  img {\n    width: 300px;\n  }\n  ", ";\n"], ["\n  flex: 1;\n  img {\n    width: 300px;\n  }\n  ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 0;\n    text-align: center;\n    left: 0; \n    right: 0;\n    img {\n      height: 400px;\n      width: auto;\n      margin: 0 auto;\n    }\n  "], ["\n    position: absolute;\n    top: 0;\n    text-align: center;\n    left: 0; \n    right: 0;\n    img {\n      height: 400px;\n      width: auto;\n      margin: 0 auto;\n    }\n  "]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ContentSection = __webpack_require__("./src/components/blocks/ContentSection.js");
	
	var _ContentSection2 = _interopRequireDefault(_ContentSection);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _Button = __webpack_require__("./src/components/atoms/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Flex = __webpack_require__("./src/components/blocks/Flex.js");
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _Pad = __webpack_require__("./src/components/blocks/Pad.js");
	
	var _Pad2 = _interopRequireDefault(_Pad);
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _Emphasis = __webpack_require__("./src/components/atoms/Emphasis.js");
	
	var _Emphasis2 = _interopRequireDefault(_Emphasis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CoupleSection = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.media.mobile(_templateObject2);
	});
	
	var CoupleImageWrapper = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.theme.media.mobile(_templateObject4);
	});
	
	exports.default = function (_ref) {
	  var content = _ref.content;
	  return _react2.default.createElement(
	    _Section2.default,
	    null,
	    _react2.default.createElement(
	      CoupleSection,
	      null,
	      _react2.default.createElement(
	        _Pad2.default,
	        { v: 5, h: 1, style: { flex: 1 } },
	        _react2.default.createElement(_Emphasis2.default, null),
	        _react2.default.createElement(_ContentSection2.default, {
	          padding: false,
	          bold: false,
	          titleText: content.maleTitle,
	          bodyText: [content.maleBody.maleBody]
	        })
	      ),
	      _react2.default.createElement(
	        CoupleImageWrapper,
	        null,
	        _react2.default.createElement("img", { src: content.coupleImage.responsiveResolution.src })
	      ),
	      _react2.default.createElement(
	        _Pad2.default,
	        { v: 5, h: 1, style: { flex: 1 } },
	        _react2.default.createElement(_Emphasis2.default, { align: "flex-end" }),
	        _react2.default.createElement(_ContentSection2.default, {
	          padding: false,
	          align: "right",
	          bold: false,
	          titleText: content.femaleTitle,
	          bodyText: [content.femaleBody.femaleBody]
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _typography.H3,
	      { align: "center", style: { width: "100%" } },
	      "Interested in clinical trials?"
	    ),
	    _react2.default.createElement(_Spacer2.default, { span: 0.5 }),
	    _react2.default.createElement(
	      _Flex2.default,
	      { justify: "center" },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/participate", style: { textDecoration: "none" } },
	        _react2.default.createElement(
	          _Button2.default,
	          null,
	          "Learn more"
	        )
	      )
	    ),
	    _react2.default.createElement(_Spacer2.default, { span: 3 })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/HeroMission.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  line-height: 1.5;\n  padding: 1rem;\n  padding-top: 2rem;\n  text-align: center;\n  ", ";\n  font-size: 2.5rem;\n  font-weight: 600;\n  transition: opacity 500ms;\n\n  ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  line-height: 1.5;\n  padding: 1rem;\n  padding-top: 2rem;\n  text-align: center;\n  ", ";\n  font-size: 2.5rem;\n  font-weight: 600;\n  transition: opacity 500ms;\n\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    font-size: 2rem;\n  "], ["\n    font-size: 2rem;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  padding-top: 10vh;\n  left: 0;\n  right: 0;\n  opacity: ", ";\n  transform: translateY(", ");\n  transition: opacity 500ms, transform 500ms;\n  height: 48rem;\n  ", ";\n"], ["\n  padding-top: 10vh;\n  left: 0;\n  right: 0;\n  opacity: ", ";\n  transform: translateY(", ");\n  transition: opacity 500ms, transform 500ms;\n  height: 48rem;\n  ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  opacity: ", ";\n  transition-delay: opacity 1500ms;\n  transition: transform 500ms, opacity 500ms;\n  padding-top: 3rem;\n  @media (max-width: 960px) {\n    padding-top: 1rem;\n    padding-bottom: 1.5rem;\n  }\n"], ["\n  opacity: ", ";\n  transition-delay: opacity 1500ms;\n  transition: transform 500ms, opacity 500ms;\n  padding-top: 3rem;\n  @media (max-width: 960px) {\n    padding-top: 1rem;\n    padding-bottom: 1.5rem;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  transform: ", ";\n  opacity: ", ";\n  transition: opacity 500ms, transform 500ms;\n  animation: anim 0.7s 1 ease;\n"], ["\n  transform: ", ";\n  opacity: ", ";\n  transition: opacity 500ms, transform 500ms;\n  animation: anim 0.7s 1 ease;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  transform: ", ";\n  transition: transform 500ms;\n  width: 14rem;\n  padding: 0 1rem;\n  height: 12rem;\n  display: flex;\n  justify: center;\n  align: flex - start;\n  img {\n    width: 100%;\n  }\n  @media (max-width: 960px) {\n    width: 8rem;\n    height: 7rem;\n    padding-bottom: 1.5rem;\n  }\n"], ["\n  transform: ", ";\n  transition: transform 500ms;\n  width: 14rem;\n  padding: 0 1rem;\n  height: 12rem;\n  display: flex;\n  justify: center;\n  align: flex - start;\n  img {\n    width: 100%;\n  }\n  @media (max-width: 960px) {\n    width: 8rem;\n    height: 7rem;\n    padding-bottom: 1.5rem;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["@media (max-width: 960px) {font-size: 1rem;}"], ["@media (max-width: 960px) {font-size: 1rem;}"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  ", ";\n"], ["\n  flex: 1;\n  ", ";\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["position: relative;"], ["position: relative;"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTimeout = __webpack_require__("./node_modules/react-timeout/src/web.js");
	
	var _reactTimeout2 = _interopRequireDefault(_reactTimeout);
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _recompose = __webpack_require__("./node_modules/recompose/cjs/Recompose.js");
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _reactWaypoint = __webpack_require__("./node_modules/react-waypoint/build/waypoint.js");
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactMarkdown = __webpack_require__("./node_modules/react-markdown/src/react-markdown.js");
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _AspectImage = __webpack_require__("./src/components/atoms/AspectImage.js");
	
	var _AspectImage2 = _interopRequireDefault(_AspectImage);
	
	var _Flex = __webpack_require__("./src/components/blocks/Flex.js");
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Quote = _typography.H3.extend(_templateObject, _utils.getFontFamily, function (props) {
	  return props.theme.media.mobile(_templateObject2);
	});
	
	var ChoiceSlider = _styledComponents2.default.div(_templateObject3, function (_ref) {
	  var stage = _ref.stage;
	  return stage < 0 ? 0 : 1;
	}, function (_ref2) {
	  var stage = _ref2.stage;
	  return stage < 2 ? 0 : "3vh";
	}, function (props) {
	  return props.theme.media.mobile(_templateObject2);
	});
	
	var Grid = _styledComponents2.default.div(_templateObject4);
	
	var DescriptionGrid = Grid.extend(_templateObject5, function (_ref3) {
	  var stage = _ref3.stage;
	  return stage < 2 ? 0 : 1;
	});
	
	var QuoteWrapper = _styledComponents2.default.div(_templateObject6, function (_ref4) {
	  var stage = _ref4.stage;
	  return stage > 1 ? "translateY(4rem)" : "translateY(-10rem)";
	}, function (_ref5) {
	  var stage = _ref5.stage;
	  return stage > 0 ? "1" : "0";
	});
	
	var Block = _styledComponents2.default.div(_templateObject7, function (_ref6) {
	  var index = _ref6.index,
	      stage = _ref6.stage;
	
	  return {
	    0: "translateY(4rem)",
	    1: "translateY(4rem)",
	    2: "translateY(8rem)",
	    3: "translateY(8rem)"
	  }[stage];
	});
	
	var BlockDescription = _typography.P.extend(_templateObject8);
	
	var Method = _styledComponents2.default.div(_templateObject9, (0, _utils.r)("padding", "1.5rem", "2rem 25vw"));
	
	var StageWaypoint = function StageWaypoint(_ref7) {
	  var stage = _ref7.stage,
	      onStageChange = _ref7.onStageChange,
	      position = _ref7.position;
	  return _react2.default.createElement(
	    _reactWaypoint2.default,
	    {
	      onPositionChange: function onPositionChange(_ref8) {
	        var currentPosition = _ref8.currentPosition,
	            previousPosition = _ref8.previousPosition;
	
	        if (currentPosition === "inside" && previousPosition === "above") onStageChange(stage);
	        if (currentPosition === "above") onStageChange(stage + 1);
	      }
	    },
	    _react2.default.createElement("div", {
	      className: "stage-" + stage,
	      style: { position: "absolute", top: position }
	    })
	  );
	};
	
	var MissionTracks = _styledComponents2.default.div(_templateObject10);
	
	var MissionAnimation = function MissionAnimation(_ref9) {
	  var quote = _ref9.quote,
	      src = _ref9.src,
	      stage = _ref9.stage,
	      onStageChange = _ref9.onStageChange,
	      _ref9$descriptions = _ref9.descriptions,
	      descriptions = _ref9$descriptions === undefined ? [""] : _ref9$descriptions;
	  return _react2.default.createElement(
	    MissionTracks,
	    null,
	    _react2.default.createElement(StageWaypoint, { stage: 1, position: "10px", onStageChange: onStageChange }),
	    _react2.default.createElement(
	      ChoiceSlider,
	      { stage: stage },
	      _react2.default.createElement(
	        Grid,
	        { stage: stage },
	        src.map(function (src) {
	          return _react2.default.createElement(
	            Block,
	            { stage: stage },
	            _react2.default.createElement("img", { src: src.responsiveResolution.src })
	          );
	        })
	      ),
	      _react2.default.createElement(
	        _Flex2.default,
	        { direction: "column" },
	        _react2.default.createElement(
	          _Flex2.default,
	          { justify: "center", align: "flex-start" },
	          _react2.default.createElement(
	            DescriptionGrid,
	            { stage: stage, pad: true },
	            descriptions.map(function (text) {
	              return _react2.default.createElement(
	                Block,
	                { stage: stage, active: 2 },
	                _react2.default.createElement(
	                  BlockDescription,
	                  { align: "center", style: { width: "100%" } },
	                  _react2.default.createElement(_reactMarkdown2.default, { source: text })
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          QuoteWrapper,
	          { stage: stage },
	          _react2.default.createElement(
	            Quote,
	            { serif: true, align: "center" },
	            _react2.default.createElement(_reactMarkdown2.default, { source: quote })
	          )
	        )
	      ),
	      _react2.default.createElement(Grid, { stage: stage })
	    )
	  );
	};
	
	var HeroMission = function HeroMission(_ref10) {
	  var _ref10$quote = _ref10.quote,
	      quote = _ref10$quote === undefined ? "" : _ref10$quote,
	      _ref10$descriptions = _ref10.descriptions,
	      descriptions = _ref10$descriptions === undefined ? [""] : _ref10$descriptions,
	      _ref10$src = _ref10.src,
	      src = _ref10$src === undefined ? {} : _ref10$src,
	      _ref10$stage = _ref10.stage,
	      stage = _ref10$stage === undefined ? -1 : _ref10$stage,
	      onStageChange = _ref10.onStageChange,
	      props = _objectWithoutProperties(_ref10, ["quote", "descriptions", "src", "stage", "onStageChange"]);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Responsive.ShowMobile,
	      null,
	      _react2.default.createElement(
	        "div",
	        {
	          style: {
	            display: "flex",
	            flexDirection: "column",
	            justifyContent: "center",
	            paddingTop: "4rem"
	          }
	        },
	        _react2.default.createElement(
	          _Flex2.default,
	          { direction: "column", align: "stretch" },
	          src.map(function (_ref11, index) {
	            var responsiveResolution = _ref11.responsiveResolution,
	                description = _ref11.description;
	            return _react2.default.createElement(
	              Method,
	              null,
	              _react2.default.createElement(_AspectImage2.default, {
	                aspect: 1,
	                src: responsiveResolution.src,
	                key: index
	              }),
	              _react2.default.createElement(
	                _typography.P,
	                { align: "center", style: { paddingTop: "1rem" } },
	                description
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(_Spacer2.default, { span: 8 }),
	        _react2.default.createElement(
	          Quote,
	          { serif: true, stage: stage, align: "center" },
	          _react2.default.createElement(_reactMarkdown2.default, { source: quote })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Responsive.HideMobile,
	      null,
	      _react2.default.createElement(MissionAnimation, {
	        quote: quote,
	        src: src,
	        stage: stage,
	        onStageChange: onStageChange,
	        descriptions: descriptions
	      })
	    )
	  );
	};
	
	exports.default = (0, _recompose.compose)(_reactTimeout2.default, (0, _recompose.withState)("stage", "onStageChange", -1), (0, _recompose.lifecycle)({
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.props.setTimeout(function () {
	      _this.props.onStageChange(0);
	      _this.props.setTimeout(function () {
	        _this.props.onStageChange(1);
	      }, 500);
	    }, 500);
	  }
	}))(HeroMission);
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/HeroQuote.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: grid;\n  text-align: center;\n  background-color: ", ";\n  color: ", ";\n  align-conent: center;\n  margin: auto;\n  padding: ", ";\n"], ["\n  display: grid;\n  text-align: center;\n  background-color: ", ";\n  color: ", ";\n  align-conent: center;\n  margin: auto;\n  padding: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  line-height: 1.5;\n  padding: 1rem;\n  text-align: center;\n  ", ";\n  font-size: 2.5rem;\n  font-weight: 400;\n  strong {\n    font-weight: 500;\n  }\n\n  ", ";\n"], ["\n  display: inline-block;\n  line-height: 1.5;\n  padding: 1rem;\n  text-align: center;\n  ", ";\n  font-size: 2.5rem;\n  font-weight: 400;\n  strong {\n    font-weight: 500;\n  }\n\n  ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    font-size: 1.65rem;\n  "], ["\n    font-size: 1.65rem;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  line-height: 1.5;\n  font-size: 1rem;\n  text-align: center;\n"], ["\n  line-height: 1.5;\n  font-size: 1rem;\n  text-align: center;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactMarkdown = __webpack_require__("./node_modules/react-markdown/src/react-markdown.js");
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _FadeIn = __webpack_require__("./src/components/atoms/FadeIn.js");
	
	var _FadeIn2 = _interopRequireDefault(_FadeIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = _styledComponents2.default.div(_templateObject, function (_ref) {
	  var theme = _ref.theme,
	      color = _ref.color;
	  return theme.colors[color];
	}, function (_ref2) {
	  var theme = _ref2.theme,
	      fontColor = _ref2.fontColor;
	  return theme.colors[fontColor];
	}, function (_ref3) {
	  var padding = _ref3.padding;
	  return padding ? padding : "8rem 6.25rem 12rem 6.25rem";
	});
	
	var Quote = _typography.H3.extend(_templateObject2, _utils.getFontFamily, function (props) {
	  return props.theme.media.tablet(_templateObject3);
	});
	
	var Author = _typography.P.extend(_templateObject4);
	
	exports.default = function (_ref4) {
	  var _ref4$color = _ref4.color,
	      color = _ref4$color === undefined ? "transparent" : _ref4$color,
	      _ref4$quote = _ref4.quote,
	      quote = _ref4$quote === undefined ? "" : _ref4$quote,
	      _ref4$author = _ref4.author,
	      author = _ref4$author === undefined ? "" : _ref4$author,
	      _ref4$fontColor = _ref4.fontColor,
	      fontColor = _ref4$fontColor === undefined ? "dark" : _ref4$fontColor,
	      _ref4$padding = _ref4.padding,
	      padding = _ref4$padding === undefined ? null : _ref4$padding,
	      _ref4$zIndex = _ref4.zIndex,
	      zIndex = _ref4$zIndex === undefined ? null : _ref4$zIndex,
	      _ref4$style = _ref4.style,
	      style = _ref4$style === undefined ? {} : _ref4$style,
	      props = _objectWithoutProperties(_ref4, ["color", "quote", "author", "fontColor", "padding", "zIndex", "style"]);
	
	  return _react2.default.createElement(
	    Section,
	    {
	      color: color,
	      fontColor: fontColor,
	      padding: padding,
	      style: _extends({}, style, { zIndex: zIndex })
	    },
	    _react2.default.createElement(
	      _FadeIn2.default,
	      null,
	      _react2.default.createElement(
	        Quote,
	        props,
	        _react2.default.createElement(_reactMarkdown2.default, { source: quote })
	      ),
	      _react2.default.createElement(
	        Author,
	        { align: "center" },
	        author
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/PictureCard.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  height: 20rem;\n  ", ";\n"], ["\n  display: flex;\n  height: 20rem;\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    flex-wrap: wrap;\n    height: auto;\n  "], ["\n    flex-wrap: wrap;\n    height: auto;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  background-color: ", ";\n  padding: 3rem;\n  ", ";\n"], ["\n  color: ", ";\n  background-color: ", ";\n  padding: 3rem;\n  ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n    padding: 2rem;\n  "], ["\n    padding: 2rem;\n  "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  font-size: 1.35rem;\n  ", ";\n  a,\n  a:visited {\n    color: white;\n  }\n"], ["\n  font-size: 1.35rem;\n  ", ";\n  a,\n  a:visited {\n    color: white;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n    font-size: 1.1rem;\n  "], ["\n    font-size: 1.1rem;\n  "]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMarkdown = __webpack_require__("./node_modules/react-markdown/src/react-markdown.js");
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _Background = __webpack_require__("./src/components/blocks/Background.js");
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _AspectImage = __webpack_require__("./src/components/atoms/AspectImage.js");
	
	var _AspectImage2 = _interopRequireDefault(_AspectImage);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _utils = __webpack_require__("./src/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _Background2.default.extend(_templateObject, function (props) {
	  return props.theme.media.mobile(_templateObject2);
	});
	
	var Body = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.theme.colors.white;
	}, (0, _utils.getThemeColor)("teal"), function (props) {
	  return props.theme.media.tablet(_templateObject4);
	});
	
	var BodyText = _typography.P.extend(_templateObject5, function (props) {
	  return props.theme.media.card(_templateObject6);
	});
	
	exports.default = function (_ref) {
	  var _ref$picture = _ref.picture,
	      picture = _ref$picture === undefined ? "" : _ref$picture,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? "" : _ref$title,
	      _ref$subtitle = _ref.subtitle,
	      subtitle = _ref$subtitle === undefined ? "" : _ref$subtitle,
	      _ref$text = _ref.text,
	      text = _ref$text === undefined ? "" : _ref$text,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? "teal" : _ref$color,
	      _ref$pictureAlign = _ref.pictureAlign,
	      pictureAlign = _ref$pictureAlign === undefined ? "left" : _ref$pictureAlign;
	  return _react2.default.createElement(
	    _Section2.default,
	    { color: "halfGrey", fixed: true },
	    _react2.default.createElement(
	      Container,
	      { color: "halfGrey", style: { display: "flex" } },
	      pictureAlign === "left" && _react2.default.createElement(
	        _Responsive.HideMobile,
	        { style: { flex: 1 } },
	        _react2.default.createElement(_AspectImage2.default, { direction: "vertical", aspect: 1, src: picture, inline: true })
	      ),
	      _react2.default.createElement(
	        _Responsive.ShowMobile,
	        null,
	        _react2.default.createElement(_AspectImage2.default, { direction: "horizontal", aspect: 1, src: picture, inline: true })
	      ),
	      _react2.default.createElement(
	        Body,
	        { color: color, style: { flex: 2 } },
	        _react2.default.createElement(
	          _typography.P,
	          { serif: true, color: "white" },
	          title
	        ),
	        _react2.default.createElement(
	          _typography.Description,
	          { color: "white" },
	          subtitle
	        ),
	        _react2.default.createElement(_Spacer2.default, { span: 0.5 }),
	        _react2.default.createElement(
	          BodyText,
	          { color: "white" },
	          _react2.default.createElement(_reactMarkdown2.default, { source: text })
	        )
	      ),
	      pictureAlign === "right" && _react2.default.createElement(
	        _Responsive.HideMobile,
	        { style: { flex: 1 } },
	        _react2.default.createElement(_AspectImage2.default, { direction: "vertical", aspect: 1, src: picture, inline: true })
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/vercel/path0/node_modules/babel-preset-react-app/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/react-hot-loader/babel.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/mission.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  opacity: ", ";\n  transition: opacity 1s;\n"], ["\n  opacity: ", ";\n  transition: opacity 1s;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  flex: 4;\n  margin-left: -2rem;\n\n  ", ";\n"], ["\n  flex: 4;\n  margin-left: -2rem;\n\n  ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    margin-left: 0rem;\n    padding-right: 3rem;\n  "], ["\n    margin-left: 0rem;\n    padding-right: 3rem;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n\n  ", ";\n"], ["\n  width: 100%;\n\n  ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    width: 80%;\n    padding-right: 1rem;\n    padding-bottom: 1rem;\n  "], ["\n    width: 80%;\n    padding-right: 1rem;\n    padding-bottom: 1rem;\n  "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  flex: 5;\n  padding-left: 6rem;\n\n  ", ";\n"], ["\n  flex: 5;\n  padding-left: 6rem;\n\n  ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n    padding-left: 1rem;\n    padding-right: 1rem;\n  "], ["\n    padding-left: 1rem;\n    padding-right: 1rem;\n  "]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _recompose = __webpack_require__("./node_modules/recompose/cjs/Recompose.js");
	
	var _selectors = __webpack_require__("./src/selectors.js");
	
	var _NavBar = __webpack_require__("./src/components/NavBar.js");
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _AspectImage = __webpack_require__("./src/components/atoms/AspectImage.js");
	
	var _AspectImage2 = _interopRequireDefault(_AspectImage);
	
	var _HeroQuote = __webpack_require__("./src/components/HeroQuote.js");
	
	var _HeroQuote2 = _interopRequireDefault(_HeroQuote);
	
	var _Pad = __webpack_require__("./src/components/blocks/Pad.js");
	
	var _Pad2 = _interopRequireDefault(_Pad);
	
	var _Flex = __webpack_require__("./src/components/blocks/Flex.js");
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _Background = __webpack_require__("./src/components/blocks/Background.js");
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _ContentSection = __webpack_require__("./src/components/blocks/ContentSection.js");
	
	var _ContentSection2 = _interopRequireDefault(_ContentSection);
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Couple = __webpack_require__("./src/components/Couple.js");
	
	var _Couple2 = _interopRequireDefault(_Couple);
	
	var _PictureCard = __webpack_require__("./src/components/PictureCard.js");
	
	var _PictureCard2 = _interopRequireDefault(_PictureCard);
	
	var _reactWaypoint = __webpack_require__("./node_modules/react-waypoint/build/waypoint.js");
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _HeroMission = __webpack_require__("./src/components/HeroMission.js");
	
	var _HeroMission2 = _interopRequireDefault(_HeroMission);
	
	var _logofavcon2x = __webpack_require__("./assets/logofavcon@2x.png");
	
	var _logofavcon2x2 = _interopRequireDefault(_logofavcon2x);
	
	var _theme = __webpack_require__("./src/styles/theme.js");
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FadeOut = _styledComponents2.default.div(_templateObject, function (_ref) {
	  var visible = _ref.visible;
	  return visible ? 1 : 0;
	});
	
	var GlobeWrapper = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.theme.media.tablet(_templateObject3);
	});
	
	var GlobeImage = _styledComponents2.default.img(_templateObject4, function (props) {
	  return props.theme.media.mobile(_templateObject5);
	});
	
	var Impact = _styledComponents2.default.div(_templateObject6, function (props) {
	  return props.theme.media.tablet(_templateObject7);
	});
	
	var MissionPage = function MissionPage(_ref2) {
	  var background = _ref2.background,
	      onColorChange = _ref2.onColorChange,
	      data = _ref2.data;
	
	  var content = (0, _selectors.getGraphNode)(data, "MissionPage");
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Background2.default,
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: "Contraline Mission",
	          meta: [{ name: "Contraline", content: "Mission" }]
	        },
	        _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _logofavcon2x2.default })
	      ),
	      _react2.default.createElement(_NavBar2.default, { color: "dark" }),
	      _react2.default.createElement(_HeroMission2.default, {
	        serif: true,
	        src: content.heroImages,
	        quote: content.heroQuote,
	        descriptions: content.heroImageDescriptions.heroImageDescriptions.split("|"),
	        style: { flex: 1 }
	      }),
	      _react2.default.createElement(
	        FadeOut,
	        { visible: background !== "teal" },
	        _react2.default.createElement(
	          _Pad2.default,
	          { v: 8 },
	          _react2.default.createElement(_Spacer2.default, { span: 4 }),
	          _react2.default.createElement(_HeroQuote2.default, { fontColor: "dark", quote: content.secondQuote })
	        )
	      ),
	      _react2.default.createElement(
	        _Pad2.default,
	        { v: 0 },
	        _react2.default.createElement(
	          _reactWaypoint2.default,
	          {
	            bottomOffset: "40%",
	            topOffset: "40%",
	            onEnter: function onEnter() {
	              return onColorChange("teal");
	            },
	            onLeave: function onLeave() {
	              return onColorChange("transparent");
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: "flex",
	                justifyContent: "center",
	                alignItems: "center",
	                flexDirection: "column"
	              }
	            },
	            _react2.default.createElement(_HeroQuote2.default, {
	              fontColor: "white",
	              quote: content.missionStatement.missionStatement,
	              padding: "0rem 6.25rem 12rem 6.25rem",
	              zIndex: 3
	            })
	          )
	        ),
	        _react2.default.createElement("div", {
	          style: {
	            background: _theme2.default.colors.teal,
	            pointerEvents: "none",
	            position: "fixed",
	            opacity: background === "teal" ? 1 : 0,
	            transition: "opacity 1000ms",
	            top: 0,
	            bottom: 0,
	            left: 0,
	            right: 0,
	            zIndex: 2
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { v: 8 },
	        _react2.default.createElement(
	          _Flex.HFlexFlipper,
	          null,
	          _react2.default.createElement(
	            GlobeWrapper,
	            null,
	            _react2.default.createElement(GlobeImage, { src: content.globe.responsiveResolution.src })
	          ),
	          _react2.default.createElement(
	            Impact,
	            null,
	            _react2.default.createElement(
	              _typography.H3,
	              null,
	              content.impactTitle
	            ),
	            _react2.default.createElement(
	              _typography.P,
	              null,
	              content.impactStatistic.impactStatistic
	            ),
	            _react2.default.createElement(_Spacer2.default, { span: 0.5 }),
	            _react2.default.createElement(
	              _typography.Description,
	              null,
	              content.impactAttribution
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Spacer2.default, { span: 4 }),
	      _react2.default.createElement(
	        FadeOut,
	        { visible: background !== "teal" },
	        _react2.default.createElement(
	          _Background2.default,
	          { color: "halfGrey" },
	          _react2.default.createElement(_PictureCard2.default, {
	            picture: content.paulTurekImage.responsiveResolution.src,
	            title: content.paulTurekTitle,
	            text: "\"" + content.paulTurekBody.paulTurekBody + "\"",
	            subtitle: content.paulTurekSubtitle
	          })
	        ),
	        _react2.default.createElement(_ContentSection2.default, {
	          color: "greyLight",
	          titleText: content.grandTeamTitle,
	          join: true,
	          bodyText: content.grandTeamBody.grandTeamBody.split("|"),
	          link: { label: content.grandTeamLink, to: "/team" }
	        })
	      )
	    )
	  );
	};
	
	var enhance = (0, _recompose.withState)("background", "onColorChange", "transparent");
	
	exports.default = enhance(MissionPage);
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ "./src/styles/theme.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n      @media (max-width: 600px) {\n        ", "\n      }\n  "], ["\n      @media (max-width: 600px) {\n        ", "\n      }\n  "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n      @media (max-width: 900px) {\n        ", "\n      }\n  "], ["\n      @media (max-width: 900px) {\n        ", "\n      }\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n      @media (max-width: 1200px) {\n        ", "\n      }\n  "], ["\n      @media (max-width: 1200px) {\n        ", "\n      }\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n      @media (max-width: 945px) {\n        ", "\n      }\n  "], ["\n      @media (max-width: 945px) {\n        ", "\n      }\n  "]);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = {
	  colors: {
	    red: "red",
	    salmon: "#de4b4b",
	    blue: "#4A90E2",
	    blueDark: "#005baa",
	    herrBlue: "#4363a0",
	    purpleDark: "#061e28",
	    green: "green",
	    teal: "#43bcba",
	    black: "#000000",
	    white: "#FFFFFF",
	    greyLight: "#f3f3f3",
	    greyAccent: "#d3d3d3",
	    halfGrey: "linear-gradient(to bottom, transparent 50%, #f3f3f3 50%)",
	    greyDient: "linear-gradient(180deg, #ffffff 0%, #e7e7e7 74.36%, #e3e2e2 100%)",
	    greyDientReverse: "linear-gradient(180deg, #ffffff 0%, #e7e7e7 74.36%, #e3e2e2 100%)",
	    grey: "#c3c3c3",
	    greyDark: "#979797",
	    greyTimeline: "#4A4A4A",
	    dark: "#000914",
	    transparent: "rgba(0, 0, 0, 0)"
	  },
	  media: {
	    mobile: function mobile() {
	      return (0, _styledComponents.css)(_templateObject, _styledComponents.css.apply(undefined, arguments));
	    },
	    tablet: function tablet() {
	      return (0, _styledComponents.css)(_templateObject2, _styledComponents.css.apply(undefined, arguments));
	    },
	    desktop: function desktop() {
	      return (0, _styledComponents.css)(_templateObject3, _styledComponents.css.apply(undefined, arguments));
	    },
	    card: function card() {
	      return (0, _styledComponents.css)(_templateObject4, _styledComponents.css.apply(undefined, arguments));
	    }
	  }
	};
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-mission-js-3979f9cf79b2c42be8bd.js